import "./App.css";
import Nav from "./Component/Nav";
import RoutesComp from "./Routes/Route";
import React, { useState, useEffect } from 'react';
import { BrowserRouter } from "react-router-dom";
const App = () => {
  const [matches, setMatches] = useState(window.matchMedia("(min-width: 768px)").matches);
  useEffect(() => {
  const handler = e => setMatches(e.matches);
  window.matchMedia("(min-width: 768px)").addListener(handler);
  return () => {
  window.matchMedia("(min-width: 768px)").removeListener(handler);
  };
  }, []);
  return (
    <div className="App">
      {matches && <h1></h1>}
      {!matches && <h3></h3>}
      <BrowserRouter>
       <Nav/>
       {/* <Home/> */}
       <RoutesComp/>
       </BrowserRouter>
    </div>
  );
}
export default App;